import type { AppVersionInfo } from '@shopexperts/shared'

export const loadedAppVersion = Object.freeze({
  app: 'dashboard',
  channel: 'beta',
  version: '2.2644.2',
  releasedAt: '2026-10-30T07:53:29.905Z',
  minimumSupported: Object.freeze({
    gentle: '2.2644.2',
    error: '2.2640.2',
    unsupported: '2.2628.1',
  }),
}) satisfies Readonly<AppVersionInfo>
